import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type {
	DeprecatedCountResponse,
	DeprecatedHeartbeatsCountResponse,
} from '../../../../common/types/index.tsx';

export const getDeprecatedGroupsCount = (cloudId: string) => {
	const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/changeboarding/groups`;

	return performGetRequest<DeprecatedCountResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getDeprecatedGroupsCountEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});

		throw err;
	});
};

export const getDeprecatedNotificationPoliciesCount = (cloudId: string) => {
	const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/changeboarding/policies`;

	return performGetRequest<DeprecatedCountResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getDeprecatedNotificationPoliciesCountEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});

		throw err;
	});
};

export const getDeprecatedHeartbeatsCount = (cloudId: string) => {
	const url = `/gateway/api/jsm/ops/web/${cloudId}/v1/heartbeats/changeboarding`;

	return performGetRequest<DeprecatedHeartbeatsCountResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getDeprecatedHeartbeatsCountEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});

		throw err;
	});
};
